import type { ManageAPI } from "~/manage-api/types";

/* height / width */
export const imageRatioValues = {
    OFFER: 1,
    BIOREX: 103 / 72,
    INSTAGRAM: 1,
    BUSINESS: 103 / 72
}

export const biorexAreaID = 13

export const CHILDREN_FOB_ID = 1090

export function getFobs(scdata: ManageAPI.ShoppingCenterData) {
    return scdata?.b2c_fobs?.map(fob=>({
        id: (Number(fob.id) + 1) * 10 + 1000, // make it clear that this is not one to one with id from api
        fob_ids: fob.fob_ids,
        description: fob.description
    }));
}